import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _objectWithoutProperties from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _cloneDeep from "lodash/cloneDeep";
var _excluded = ["meta"];
import "core-js/modules/es6.set.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable no-param-reassign */
import produce, { current } from 'immer';
import initialState from '../initialState';
var loadedProcessingConfig = produce(function (draft, action) {
  var _oldConfig$meta$steps, _oldConfig$meta;
  var data = action.payload.data;
  var newConfig = _cloneDeep(data);
  var oldConfig = current(draft.processing);
  newConfig.meta = _objectSpread(_objectSpread(_objectSpread({}, oldConfig.meta), newConfig.meta), {}, {
    loading: false,
    loadingSettingsError: false,
    stepsDone: new Set((_oldConfig$meta$steps = (_oldConfig$meta = oldConfig.meta) === null || _oldConfig$meta === void 0 ? void 0 : _oldConfig$meta.stepsDone) !== null && _oldConfig$meta$steps !== void 0 ? _oldConfig$meta$steps : [])
  });
  var meta = newConfig.meta,
    newConfigWithoutMeta = _objectWithoutProperties(newConfig, _excluded);
  draft.originalProcessing = _cloneDeep(newConfigWithoutMeta);
  draft.processing = newConfig;
}, initialState);
export default loadedProcessingConfig;